<script setup lang="ts">
type Props = {
  tags: GameTag[] | undefined | null;
  // Reseta o dropdown ativo quando muda. Geralmente o id do jogo.
  resetKey?: string | number | null;
  dropdownWidth?: number;
};

const props = withDefaults(defineProps<Props>(), {
  resetKey: null,
  dropdownWidth: 200,
});

const { getTagStyle } = useRibbon();

const TAG_SVG_MAP: Record<string, string> = {
  GEMAS: `<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#mgp-tag-gemas-clip)"><path d="M3.19922 7.63164V5.36832C3.19922 5.2171 3.2226 5.06679 3.26853 4.92271L1.18143 3.4917C1.17258 3.54388 1.16807 3.5967 1.16797 3.64963V9.35033C1.16801 9.44369 1.18187 9.53652 1.2091 9.62582L3.2726 8.08969C3.22399 7.94187 3.19922 7.78725 3.19922 7.63164Z" fill="currentColor"/><path d="M9.80092 5.36843V7.63175C9.80081 7.78702 9.77604 7.94128 9.72754 8.08878L11.8322 9.65614C11.8322 9.65106 11.8322 9.64624 11.8322 9.64116V3.48267L9.7316 4.92282C9.77754 5.0669 9.80092 5.21721 9.80092 5.36843Z" fill="currentColor"/><path d="M9.03882 7.63147V5.36814C9.03895 5.23818 9.0009 5.11104 8.92939 5.00252C8.87329 4.91751 8.79774 4.84709 8.709 4.79711L6.8047 3.72842C6.71315 3.67675 6.60996 3.64922 6.50484 3.64844H6.49569C6.39038 3.64886 6.28692 3.67613 6.19507 3.72766L4.29077 4.79635C4.20203 4.84633 4.12648 4.91675 4.07038 5.00176C3.99887 5.11028 3.96081 5.23742 3.96095 5.36738V7.6307C3.96028 7.74673 3.9905 7.86084 4.04851 7.96133C4.10652 8.06181 4.19022 8.14505 4.29103 8.2025L6.19532 9.27119C6.28687 9.32286 6.39007 9.35038 6.49519 9.35117H6.50433C6.60947 9.35066 6.71275 9.3234 6.80444 9.27195L8.70874 8.20326C8.80955 8.14581 8.89325 8.06257 8.95126 7.96209C9.00926 7.8616 9.03949 7.74749 9.03882 7.63147Z" fill="currentColor"/><path d="M6.11908 10.08C6.01846 10.0508 5.92152 10.0102 5.83014 9.95893L3.92584 8.89049C3.84693 8.8461 3.77252 8.79414 3.70367 8.73535L1.72168 10.2103L6.11908 13V10.08Z" fill="currentColor"/><path d="M9.29627 8.73438C9.22742 8.79317 9.15301 8.84512 9.0741 8.88951L7.1698 9.95795C7.07847 10.0096 6.98152 10.0505 6.88086 10.0801V13L11.2783 10.2103L9.29627 8.73438Z" fill="currentColor"/><path d="M3.69297 4.274C3.76468 4.21171 3.84252 4.15684 3.92529 4.11023L5.82959 3.0418C5.92094 2.99027 6.01788 2.94938 6.11854 2.91992V0L1.62109 2.85314L3.69297 4.274Z" fill="currentColor"/><path d="M6.88086 0V2.91992C6.98148 2.94914 7.07842 2.98977 7.1698 3.04103L9.0741 4.10947C9.15688 4.15607 9.23472 4.21094 9.30643 4.27324L11.3783 2.85137L6.88086 0Z" fill="currentColor"/></g><defs><clipPath id="mgp-tag-gemas-clip"><rect width="13" height="13" fill="white"/></clipPath></defs></svg>`,
  DIAMANTES: `<svg width="14" height="14" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#mgp-tag-diamantes-clip)"><path d="M2.94435 1.8125H11.5562C11.6514 1.81249 11.7455 1.83504 11.8304 1.87829C11.9153 1.92156 11.9889 1.98431 12.0449 2.06142L14.3547 5.23692C14.3957 5.29342 14.4159 5.3624 14.4118 5.43213C14.4078 5.50186 14.3796 5.56802 14.3323 5.61935L7.472 13.0512C7.44367 13.0818 7.40941 13.1062 7.37123 13.1229C7.33311 13.1395 7.2919 13.1481 7.25027 13.1481C7.20859 13.1481 7.16738 13.1395 7.12926 13.1229C7.09108 13.1062 7.05682 13.0818 7.02855 13.0512L0.168204 5.61996C0.120687 5.56859 0.0924815 5.5023 0.088404 5.43244C0.084327 5.36258 0.104632 5.29347 0.14585 5.23692L2.45558 2.06142C2.51163 1.98431 2.58514 1.92156 2.67009 1.87829C2.75504 1.83504 2.84902 1.81249 2.94435 1.8125Z" fill="currentColor"/></g><defs><clipPath id="mgp-tag-diamantes-clip"><rect width="14.5" height="14.5" fill="white"/></clipPath></defs></svg>`,
  RAKEBACK: `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.56283 4.57766C6.01688 4.72694 5.68783 5.14586 5.68783 5.54163C5.68783 5.93739 6.01688 6.35631 6.56283 6.5056V4.57766Z" fill="currentColor"/><path d="M7.43783 7.49432V9.42226C7.98377 9.27298 8.31283 8.85406 8.31283 8.45829C8.31283 8.06253 7.98377 7.64361 7.43783 7.49432Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.8337 6.99996C12.8337 10.2216 10.222 12.8333 7.00033 12.8333C3.77866 12.8333 1.16699 10.2216 1.16699 6.99996C1.16699 3.7783 3.77866 1.16663 7.00033 1.16663C10.222 1.16663 12.8337 3.7783 12.8337 6.99996ZM7.00033 3.06246C7.24195 3.06246 7.43783 3.25833 7.43783 3.49996V3.68472C8.38891 3.85502 9.18783 4.56956 9.18783 5.54163C9.18783 5.78325 8.99195 5.97913 8.75033 5.97913C8.5087 5.97913 8.31283 5.78325 8.31283 5.54163C8.31283 5.14586 7.98377 4.72694 7.43783 4.57766V6.60139C8.38891 6.77168 9.18783 7.48623 9.18783 8.45829C9.18783 9.43035 8.38891 10.1449 7.43783 10.3152V10.5C7.43783 10.7416 7.24195 10.9375 7.00033 10.9375C6.7587 10.9375 6.56283 10.7416 6.56283 10.5V10.3152C5.61174 10.1449 4.81283 9.43035 4.81283 8.45829C4.81283 8.21667 5.0087 8.02079 5.25033 8.02079C5.49195 8.02079 5.68783 8.21667 5.68783 8.45829C5.68783 8.85406 6.01688 9.27298 6.56283 9.42226V7.39853C5.61174 7.22824 4.81283 6.51369 4.81283 5.54163C4.81283 4.56956 5.61174 3.85502 6.56283 3.68472V3.49996C6.56283 3.25833 6.7587 3.06246 7.00033 3.06246Z" fill="currentColor"/></svg>`,
  CASHBACK: `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 7.00248V6.56503C0.0127857 6.5223 0.0208224 6.46607 0.025206 6.4113C0.303934 3.03364 3.00244 0.321661 6.38041 0.0335558L6.61896 0.0131073C6.87759 -0.0088018 7.12089 0.000326997 7.38208 0.0145679C9.10742 0.109873 10.7111 0.823014 11.948 2.05285L12.6052 1.39922C12.6326 1.37184 12.6724 1.34555 12.6987 1.33678C12.7301 1.32619 12.8244 1.37439 12.8313 1.40762L13.0198 4.18533C13.0253 4.26603 12.9844 4.36973 12.8964 4.36389L10.0528 4.17255C10.017 4.12654 9.99218 4.05862 9.99547 4.00933L10.71 3.28925C9.15673 1.74758 6.8502 1.32546 4.85052 2.2157C2.99733 3.04058 1.73995 4.92221 1.7531 7.00357L0 7.00284L0 7.00248Z" fill="currentColor"/><path d="M7.43729 13.9998H6.56238C4.867 13.9998 3.27902 13.183 2.05415 11.9499L1.32829 12.6711C1.27934 12.6722 1.20007 12.6404 1.16865 12.6024L0.979791 9.81739C0.975773 9.75824 1.0123 9.63555 1.08792 9.64066L3.94643 9.83127C3.9826 9.88057 4.00671 9.94593 4.00488 9.99559L3.29034 10.7157C4.84874 12.261 7.16586 12.6827 9.16664 11.7826C11.0217 10.9479 12.2589 9.0608 12.2484 7.00134L13.9996 7.00207C14.0095 10.6142 11.2138 13.6781 7.58669 13.9746C7.53482 13.979 7.48222 13.9827 7.43729 13.9998Z" fill="currentColor"/><path d="M9.47859 9.56742C8.1233 10.9842 5.91942 10.9893 4.55501 9.60211C3.15881 8.1824 3.14712 5.86332 4.52761 4.42973C5.89093 3.01404 8.10979 3.01295 9.47274 4.42973C10.8357 5.84652 10.847 8.13639 9.47859 9.56706V9.56742ZM7.40913 9.6368L7.41498 9.14567C8.10796 9.04562 8.57665 8.43363 8.51783 7.76284C8.45975 7.09936 7.90193 6.58778 7.22064 6.59143L6.77971 6.59362C6.50354 6.59509 6.29057 6.38074 6.29751 6.11564C6.30445 5.85054 6.51158 5.66249 6.78008 5.66358L7.22064 5.66504C7.49023 5.66614 7.68202 5.86734 7.69882 6.13061L8.51199 6.12769C8.51053 5.4759 8.03673 4.95628 7.41023 4.85587V4.36656H6.59012V4.8555C5.91394 4.95336 5.43174 5.54746 5.48032 6.21971C5.52891 6.89195 6.09038 7.41156 6.78008 7.41266L7.2484 7.41339C7.51398 7.41376 7.70978 7.63978 7.70284 7.88845C7.6959 8.13712 7.50375 8.33576 7.2473 8.33759L6.78044 8.34124C6.5145 8.34343 6.3187 8.1594 6.29824 7.89064L5.48507 7.8943C5.49128 8.53842 5.95266 9.05438 6.5861 9.14823L6.59268 9.6379L7.4095 9.6368H7.40913Z" fill="currentColor"/></svg>`,
  XP: `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#mgp-tag-xp-clip)"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0C10.866 0 14 3.134 14 7C14 10.866 10.866 14 7 14C3.134 14 -2.37484e-06 10.866 0 7C0 3.134 3.134 -2.37484e-06 7 0ZM3.07344 8.39995L7.00007 4.47333L10.9267 8.39995H3.07344Z" fill="currentColor"/></g><defs><clipPath id="mgp-tag-xp-clip"><rect width="14" height="14" fill="white"/></clipPath></defs></svg>`,
  COIN: `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 14C10.866 14 14 10.866 14 7C14 3.134 10.866 0 7 0C3.134 0 0 3.134 0 7C0 10.866 3.134 14 7 14ZM7.875 4.375H6.125V9.625H7.875V4.375Z" fill="currentColor"/></svg>`,
  MISSOES: `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#mgp-tag-missoes-clip)"><path d="M6.629 5.66292L7.73652 4.55566C6.44787 3.96347 4.87014 4.19701 3.81008 5.25733C2.45002 6.61716 2.45002 8.83032 3.81008 10.1906C5.16988 11.5507 7.38334 11.5507 8.74317 10.1906C9.80323 9.13061 10.037 7.55262 9.44483 6.26395L8.33735 7.37143C8.4468 8.0181 8.2547 8.70595 7.75662 9.20383C6.94051 10.0202 5.61276 10.0202 4.79669 9.20383C3.98059 8.38773 3.98059 7.06001 4.79669 6.24413C5.29474 5.74579 5.98259 5.55344 6.629 5.66292Z" fill="currentColor"/><path d="M10.7163 12.1635C12.3499 10.5301 12.8929 8.21329 12.3461 6.12476H10.89C11.4802 7.83642 11.0936 9.81307 9.72951 11.177C7.82518 13.0813 4.72712 13.0813 2.82305 11.177C0.918717 9.27292 0.918717 6.17457 2.82305 4.27027C4.18662 2.90647 6.16327 2.51984 7.87489 3.10979V1.65372C5.78647 1.10719 3.46966 1.6502 1.83621 3.28343C-0.612071 5.73145 -0.612071 9.71548 1.83621 12.1635C4.28453 14.6121 8.26804 14.6121 10.7163 12.1635Z" fill="currentColor"/><path d="M13.9772 2.74649C13.9251 2.61069 13.7932 2.52701 13.6438 2.5338L11.3595 2.64096L11.4669 0.356896C11.4734 0.207272 11.3897 0.0759049 11.254 0.0232676C11.119 -0.0288518 10.9587 0.00866767 10.8487 0.118151L8.41106 2.55598L8.28775 5.18856L6.43077 7.04479C6.20533 6.9937 5.95927 7.05417 5.78358 7.22983C5.51094 7.50247 5.51094 7.94403 5.78358 8.21667C6.05596 8.48931 6.49778 8.48931 6.77042 8.21667C6.94581 8.04098 7.00657 7.79492 6.95546 7.56922L8.81218 5.7127L11.4445 5.58968L13.8824 3.15153C13.9921 3.04182 14.0294 2.882 13.9772 2.74649Z" fill="currentColor"/></g><defs><clipPath id="mgp-tag-missoes-clip"><rect width="14" height="14" fill="white"/></clipPath></defs></svg>`,
  TORNEIO: `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#mgp-tag-torneio-clip)"><path d="M11.0194 0H2.97694V1.28519H0.229492V3.39576C0.229492 4.91228 1.46327 6.14606 2.9798 6.14606H3.3368C3.85658 7.29131 4.8933 8.15096 6.15279 8.41942V10.1444H5.16748C4.86474 10.1444 4.61627 10.39 4.61627 10.6956V11.4182H3.7709V14H10.2254V11.4182H9.3829V10.6956C9.3829 10.3929 9.13729 10.1444 8.8317 10.1444H7.84638V8.41942C9.10587 8.1481 10.1426 7.29131 10.6624 6.14606H11.0194C12.5359 6.14606 13.7697 4.91228 13.7697 3.39576V1.28519H11.0194V0ZM2.97694 4.7552C2.22868 4.7552 1.62035 4.14688 1.62035 3.39861V2.67891H2.97694V4.49245C2.97694 4.58099 2.9798 4.66952 2.98551 4.7552H2.97694ZM8.11485 11.5496V12.9319H5.88147V11.5496H8.11485ZM8.82313 3.61281L7.99775 4.30967L8.25764 5.35781C8.3062 5.55488 8.08914 5.71195 7.91778 5.60343L7.00101 5.03223L6.08425 5.60343C5.91289 5.71195 5.69583 5.55488 5.74438 5.35781L6.00428 4.30967L5.1789 3.61281C5.02468 3.48144 5.10465 3.22725 5.30742 3.21297L6.38412 3.13586L6.79253 2.13627C6.86964 1.94778 7.13525 1.94778 7.21236 2.13627L7.62076 3.13586L8.69747 3.21297C8.89738 3.23011 8.97735 3.48144 8.82313 3.61281ZM12.376 2.67891V3.39861C12.376 4.14688 11.7676 4.7552 11.0194 4.7552H11.0108C11.0165 4.66952 11.0194 4.58099 11.0194 4.49245V2.67891H12.376Z" fill="currentColor"/></g><defs><clipPath id="mgp-tag-torneio-clip"><rect width="14" height="14" fill="white"/></clipPath></defs></svg>`,
};

const TAG_ALIAS_MAP: Record<string, keyof typeof TAG_SVG_MAP> = {
  CASHBACK: 'CASHBACK',
  RAKEBACK: 'RAKEBACK',
  XP: 'XP',
  COIN: 'COIN',
  COINS: 'COIN',
  MOEDA: 'COIN',
  MOEDAS: 'COIN',
  DIAMANTE: 'DIAMANTES',
  DIAMANTES: 'DIAMANTES',
  DIAMOND: 'DIAMANTES',
  DIAMONDS: 'DIAMANTES',
  GEM: 'GEMAS',
  GEMS: 'GEMAS',
  GEMA: 'GEMAS',
  GEMAS: 'GEMAS',
  MISSAO: 'MISSOES',
  MISSOES: 'MISSOES',
  MISSION: 'MISSOES',
  MISSIONS: 'MISSOES',
  TORNEIO: 'TORNEIO',
  TORNEIOS: 'TORNEIO',
  TOURNAMENT: 'TORNEIO',
  TOURNAMENTS: 'TORNEIO',
};

const TAG_DESCRIPTION_MAP: Record<string, string> = {
  CASHBACK:
    'Receba uma parte do valor perdido direto no seu saldo, para usar em novas jogadas ou sacar.',
  RAKEBACK:
    'Receba uma porcentagem da comissão paga em jogos, direto ao seu saldo.',
  XP: 'Este jogo concede pontos de experiência, confira mais sobre na aba de promoções.',
  COIN: 'Acumule coins enquanto joga, podendo trocá-las por prêmios e benefícios na loja.',
  DIAMANTES:
    'Este jogo dá diamantes como recompensa, item premium usado em vantagens exclusivas.',
  GEMAS:
    'Ao jogar, você ganha gemas que podem ser trocadas por bônus e vantagens na loja.',
  MISSOES:
    'Este jogo conta para missões ativas, liberando recompensas ao concluí-las jogando.',
  TORNEIO:
    'Este jogo participa de torneios com ranking e premiações para os melhores colocados.',
};

function normalizeTagKey(name?: string | null): string {
  return (name ?? '').trim().toUpperCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
}

function formatTagName(name?: string | null): string {
  const trimmed = (name ?? '').trim();

  if (!trimmed) return '';

  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
}

function getTagSvg(tag: GameTag): string | null {
  const key = normalizeTagKey(tag.name);
  const canonical = TAG_ALIAS_MAP[key] ?? key;

  return TAG_SVG_MAP[canonical] ?? null;
}

function getTagCanonical(tag: GameTag): string {
  const key = normalizeTagKey(tag.name);

  return TAG_ALIAS_MAP[key] ?? key;
}

function getTagDescription(tag: GameTag): string | null {
  return TAG_DESCRIPTION_MAP[getTagCanonical(tag)] ?? null;
}

function hexToRgb(hex: string): [number, number, number] {
  let h = hex.replace('#', '').trim();

  if (h.length === 3) {
    h = h
      .split('')
      .map((c) => c + c)
      .join('');
  }

  const num = Number.parseInt(h, 16);

  return [(num >> 16) & 255, (num >> 8) & 255, num & 255];
}

function getChipStyle(tag: GameTag) {
  const base = getTagStyle(tag);
  const color = tag.color || '#00C9FF';
  const [r, g, b] = hexToRgb(color);

  return {
    ...base,
    color,
    background: `linear-gradient(90deg, rgba(${r}, ${g}, ${b}, 0.15) 0%, rgba(${r}, ${g}, ${b}, 0) 100%)`,
    borderColor: `rgba(${r}, ${g}, ${b}, 0.3)`,
  };
}

const activeChipKey = ref<string | null>(null);
const activeChipEl = ref<HTMLElement | null>(null);
const wrapperRef = ref<HTMLElement | null>(null);
const chipsRowRef = ref<HTMLElement | null>(null);
const chipArrowLeft = ref<number>(20);
const chipDropdownLeft = ref<number>(0);

// Drag-to-scroll: usuário clica e arrasta horizontalmente pra scrollar a
// fileira de chips. Necessário no desktop (sem touch). Se o ponteiro mover
// mais que DRAG_THRESHOLD, marcamos como drag e suprimimos o click no chip.
const DRAG_THRESHOLD = 5;
let dragStartX = 0;
let dragStartScroll = 0;
let isPointerDown = false;
let isDragging = false;

function onChipsPointerDown(e: PointerEvent) {
  const row = chipsRowRef.value;

  if (!row) return;
  // Só inicia drag pra botão esquerdo / touch / pen
  if (e.button !== 0 && e.pointerType === 'mouse') return;
  isPointerDown = true;
  isDragging = false;
  dragStartX = e.clientX;
  dragStartScroll = row.scrollLeft;
}

function onChipsPointerMove(e: PointerEvent) {
  if (!isPointerDown) return;

  const row = chipsRowRef.value;

  if (!row) return;

  const dx = e.clientX - dragStartX;

  if (!isDragging && Math.abs(dx) > DRAG_THRESHOLD) {
    isDragging = true;
    row.setPointerCapture(e.pointerId);
    // Suprime seleção de texto global enquanto arrasta — sem isso o
    // navegador seleciona qualquer texto que o ponteiro cruzar.
    if (typeof document !== 'undefined') {
      document.body.classList.add('tc-dragging');
    }
  }

  if (isDragging) {
    row.scrollLeft = dragStartScroll - dx;
    e.preventDefault();
  }
}

function onChipsPointerUp(e: PointerEvent) {
  isPointerDown = false;
  if (isDragging) {
    const row = chipsRowRef.value;

    row?.releasePointerCapture(e.pointerId);
  }
  if (typeof document !== 'undefined') {
    document.body.classList.remove('tc-dragging');
  }
}

function onChipClickCapture(e: MouseEvent) {
  if (isDragging) {
    // Cancela o click do chip se foi um drag, não um click puro
    e.stopPropagation();
    e.preventDefault();
    isDragging = false;
  }
}

function updateArrowPosition() {
  const wrapper = wrapperRef.value;
  const chipEl = activeChipEl.value;

  if (!wrapper || !chipEl) return;

  const wrapperRect = wrapper.getBoundingClientRect();
  const chipRect = chipEl.getBoundingClientRect();
  const center = chipRect.left - wrapperRect.left + chipRect.width / 2;

  const maxLeft = Math.max(0, wrapperRect.width - props.dropdownWidth);
  const dropdownLeft = Math.max(
    0,
    Math.min(maxLeft, center - props.dropdownWidth / 2),
  );

  chipDropdownLeft.value = dropdownLeft;

  const min = 14;
  const max = props.dropdownWidth - 14;

  chipArrowLeft.value = Math.max(min, Math.min(max, center - dropdownLeft));
}

function toggleChip(tag: GameTag, event: MouseEvent) {
  if (!getTagDescription(tag)) return;

  const key = getTagCanonical(tag);

  if (activeChipKey.value === key) {
    activeChipKey.value = null;
    activeChipEl.value = null;

    return;
  }

  activeChipKey.value = key;
  activeChipEl.value = event.currentTarget as HTMLElement;
  updateArrowPosition();
}

function handleDocumentClick(event: MouseEvent) {
  const target = event.target as Node;

  if (
    activeChipKey.value &&
    wrapperRef.value &&
    !wrapperRef.value.contains(target)
  ) {
    activeChipKey.value = null;
    activeChipEl.value = null;
  }
}

onMounted(() => {
  document.addEventListener('click', handleDocumentClick, true);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleDocumentClick, true);
});

watch(
  () => props.resetKey,
  () => {
    activeChipKey.value = null;
    activeChipEl.value = null;
  },
);

watch(activeChipKey, (key) => {
  if (!key) {
    activeChipEl.value = null;

    return;
  }

  const chipsRow = chipsRowRef.value;

  if (!chipsRow) return;

  const onScroll = () => updateArrowPosition();

  chipsRow.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  const stop = watch(activeChipKey, (k) => {
    if (k) return;
    chipsRow.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onScroll);
    stop();
  });
});

const activeChipDescription = computed(() => {
  if (!activeChipKey.value) return null;

  return TAG_DESCRIPTION_MAP[activeChipKey.value] ?? null;
});
</script>

<template>
  <div
    v-if="tags?.length"
    ref="wrapperRef"
    class="tc-wrapper"
  >
    <div
      ref="chipsRowRef"
      class="tc-chips"
      @click.capture="onChipClickCapture"
      @pointercancel="onChipsPointerUp"
      @pointerdown="onChipsPointerDown"
      @pointermove="onChipsPointerMove"
      @pointerup="onChipsPointerUp"
    >
      <button
        v-for="tag in tags"
        :key="tag.id ?? tag.name"
        class="tc-chip"
        :class="{
          'is-active': activeChipKey === getTagCanonical(tag),
          'is-clickable': !!getTagDescription(tag),
        }"
        :draggable="false"
        :style="getChipStyle(tag)"
        type="button"
        @click="toggleChip(tag, $event)"
      >
        <span
          v-if="getTagSvg(tag)"
          class="tc-chip-icon"
          v-html="getTagSvg(tag)"
        />
        <span>{{ formatTagName(tag.name) }}</span>
      </button>
    </div>

    <Transition name="tc-dropdown">
      <div
        v-if="activeChipDescription"
        class="tc-dropdown"
        :style="{
          left: chipDropdownLeft + 'px',
          width: dropdownWidth + 'px',
        }"
      >
        <div
          class="tc-dropdown-arrow"
          :style="{ left: chipArrowLeft + 'px' }"
        />
        {{ activeChipDescription }}
      </div>
    </Transition>
  </div>
</template>

<style>
/* Global: aplicado no body enquanto o usuário arrasta a fileira de chips.
   Bloqueia seleção de texto em qualquer lugar da página durante o drag. */
body.tc-dragging,
body.tc-dragging * {
  user-select: none !important;
  -webkit-user-select: none !important;
}
</style>

<style scoped>
.tc-wrapper {
  position: relative;
}

.tc-chips {
  display: flex;
  flex-wrap: nowrap;
  gap: 5px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  cursor: grab;
  user-select: none;
  -webkit-user-select: none;
  touch-action: pan-x;
}

.tc-chips:active {
  cursor: grabbing;
}

.tc-chips::-webkit-scrollbar {
  display: none;
}

.tc-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px;
  border-radius: 6px;
  border: 1px solid;
  font-size: 10px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  flex-shrink: 0;
  font-family: inherit;
  cursor: default;
  transition: filter 0.15s ease;
}

.tc-chip.is-clickable {
  cursor: pointer;
}

.tc-chip,
.tc-chip * {
  -webkit-user-drag: none;
}

.tc-chip.is-clickable:hover {
  filter: brightness(1.15);
}

.tc-chip.is-active {
  filter: brightness(1.25);
}

.tc-chip-icon {
  display: inline-flex;
  align-items: center;
  line-height: 0;
}

.tc-dropdown {
  position: absolute;
  top: calc(100% + 10px);
  z-index: 6;
  padding: 10px;
  border-radius: 5px;
  background: #0a0f2e;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.45);
  color: #d0d5dd;
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: 15px;
  letter-spacing: -0.2px;
  text-align: left;
}

.tc-dropdown-arrow {
  position: absolute;
  top: -5px;
  width: 10px;
  height: 10px;
  background: #0a0f2e;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  border-left: 1px solid rgba(255, 255, 255, 0.08);
  transform: translateX(-50%) rotate(45deg);
  border-radius: 2px 0 0 0;
  pointer-events: none;
}

.tc-dropdown-enter-active,
.tc-dropdown-leave-active {
  transition:
    opacity 0.18s ease,
    transform 0.18s ease;
}

.tc-dropdown-enter-from,
.tc-dropdown-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>
